var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelivered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 15.999,
    viewBox: "0 0 15.999 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 15.999,
    fill: "#841474",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.073,6.138a.667.667,0,0,0-.94.113l-4.666,6L4.18,9.464a.667.667,0,1,0-1.04.833l2.78,3.453a.7.7,0,0,0,1.073-.007l5.22-6.666a.667.667,0,0,0-.14-.94Z",
    transform: "translate(-0.994 -1.998)",
    fill: "#841474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.193,6.138a.667.667,0,0,0-.94.113l-4.666,6-.407-.5-.84,1.08.733.913a.666.666,0,0,0,1.04-.007l5.22-6.666a.667.667,0,0,0-.14-.933Z",
    transform: "translate(-3.781 -1.998)",
    fill: "#841474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.472,12.3l.86-1.08-.133-.16a.664.664,0,1,0-1.053.807Z",
    transform: "translate(-2.666 -3.596)",
    fill: "#841474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelivered);
export default __webpack_public_path__ + "static/media/Icon-delivered.7a93eb1bb67464fa5303b200851fbfd1.svg";
export { ForwardRef as ReactComponent };